module.exports = __webpack_public_path__ + "static/assets/6a824e649a911ef81d67be3114a5c445.svg";